exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#forms-module-section .fb-submissions-header[data-v-14df1c19]{gap:1rem;display:flex;align-items:flex-start;justify-content:space-between}#forms-module-section .fb-submissions-header .fb-submission-header-buttons[data-v-14df1c19]{display:flex;gap:1rem}", ""]);

// exports
